import React, {useEffect, useRef, useState} from 'react';
//import {updateOpayoSettings} from "../../../../Actions/MopriSettingActions";
import {Toast} from "primereact/toast";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Controller, useForm} from "react-hook-form";
import {Dropdown} from "primereact/dropdown";
import {InputText} from "primereact/inputtext";
import {Button} from "primereact/button";
import {faCreditCard} from "@fortawesome/free-solid-svg-icons/faCreditCard";
import {useSelector} from "react-redux";
import axios from "axios";
import qs from "qs";

const opayoStatuses = [{value: true, description: 'Active'}, {value: false, description: 'Inactive'}];
const opayoEnvironments = [{value: true, description: 'Sandbox Environment'}, {value: false, description: 'Production Environment'}];

export const OpayoSettings = ({gatewaySettings}) => {
    const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false)
    const themeSettings = useSelector(state => state.theme);
    const apiURL = useSelector(state => state.mopriSettings.mopriAPIURL);
    const myToast = useRef(null)

    const { control, handleSubmit, watch, getValues,
        formState: { errors } } = useForm({
        defaultValues: {
            opayoActive: gatewaySettings.opayoActive ? gatewaySettings.opayoActive === 'true' : false,
            opayoSandbox: gatewaySettings.opayoSandbox ? gatewaySettings.opayoSandbox === 'true' : true,
            opayoProductionVendorName: gatewaySettings.opayoProductionVendorName ? gatewaySettings.opayoProductionVendorName : '',
            opayoProductionIntegrationKey:  gatewaySettings.opayoProductionIntegrationKey ? gatewaySettings.opayoProductionIntegrationKey : '',
            opayoProductionIntegrationPassword:  gatewaySettings.opayoProductionIntegrationPassword ? gatewaySettings.opayoProductionIntegrationPassword : '',
            opayoSandboxVendorName:  gatewaySettings.opayoSandboxVendorName ? gatewaySettings.opayoSandboxVendorName : '',
            opayoSandboxIntegrationKey:  gatewaySettings.opayoSandboxIntegrationKey ? gatewaySettings.opayoSandboxIntegrationKey : '',
            opayoSandboxIntegrationPassword:  gatewaySettings.opayoSandboxIntegrationPassword ? gatewaySettings.opayoSandboxIntegrationPassword : '',
        }
    })

    useEffect(() => {

    }, []);

    const onSubmit = (data) => {
        setSubmitButtonDisabled(true);
        console.log(data)

        axios({
            method: 'post',
            url: `${apiURL}/api/gateway/updateOpayo`,
            data: qs.stringify({
                ...data
            }),
            config: { headers: {'Content-Type': 'application/x-www-form-urlencoded' }}
        })


        setSubmitButtonDisabled(false);
    }

    const getFormErrorMessage = (name) => {
        return errors[name] && <small className="p-error">{errors[name].message}</small>
    };

    const opayoServiceActive = watch("opayoActive")
    const opayoSandboxStatus = watch("opayoSandbox")

    return (
        <>
            <Toast ref={myToast} />
            <div className="p-fluid grid formgrid">
                <div className="field col-12">
                    <h4><FontAwesomeIcon icon={faCreditCard} style={{paddingRight: '10px'}}/> Opayo Settings (SagePay)</h4>
                </div>
            </div>

            <div className="p-fluid grid formgrid">
                <div className="field col-12">
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="p-fluid grid formgrid" >
                            <div className="field col-6">
                                <span className="p-float-label" style={{fontSize: '12px', color: "#6c757d", paddingBottom: '5px'}}>
                                     Opayo Status
                                </span>
                                <Controller name="opayoActive" control={control}
                                            render={({ field, fieldState }) => (
                                                <Dropdown value={field.value} id={field.name}
                                                          options={opayoStatuses} optionLabel="description"
                                                          optionValue="value"
                                                          onChange={(e) => {
                                                              field.onChange(e.value)
                                                          }}
                                                />
                                            )}
                                />
                                {getFormErrorMessage('opayoActive')}
                            </div>
                            <div className="field col-6">
                                {opayoServiceActive &&
                                    <>
                                        <span className="p-float-label" style={{fontSize: '12px', color: "#6c757d", paddingBottom: '5px'}}>
                                         Opayo Status
                                        </span>
                                        <Controller name="opayoSandbox" control={control}
                                                    render={({ field, fieldState }) => (
                                                        <Dropdown value={field.value} id={field.name}
                                                                  options={opayoEnvironments} optionLabel="description"
                                                                  optionValue="value"
                                                                  onChange={(e) => {
                                                                      field.onChange(e.value)
                                                                  }}
                                                        />
                                                    )}
                                        />
                                        {getFormErrorMessage('opayoSandbox')}
                                    </>
                                }
                            </div>
                        </div>

                        {(opayoServiceActive && !opayoSandboxStatus) &&
                            <>
                                <h5>Opayo Live Environment Settings</h5>
                                <div className="p-fluid grid formgrid" >
                                    <div className="field col-6" style={{paddingTop: '27px'}}>
                                        <span className="p-float-label">
                                            <Controller name="opayoProductionVendorName" control={control}
                                                        render={({ field, fieldState }) => (
                                                            <InputText id={field.name} {...field}
                                                            />
                                                        )}
                                            />
                                            <label htmlFor="opayoProductionVendorName">Opayo Vendor Name</label>
                                        </span>
                                        {getFormErrorMessage('opayoProductionVendorName')}
                                    </div>
                                    <div className="field col-6" style={{paddingTop: '27px'}}>
                                        <span className="p-float-label">
                                            <Controller name="opayoProductionIntegrationKey" control={control}
                                                        render={({ field, fieldState }) => (
                                                            <InputText id={field.name} {...field}
                                                            />
                                                        )}
                                            />
                                            <label htmlFor="opayoProductionIntegrationKey">Opayo Integration Key</label>
                                        </span>
                                        {getFormErrorMessage('opayoProductionIntegrationKey')}
                                    </div>
                                    <div className="field col-6" style={{paddingTop: '27px'}}>
                                        <span className="p-float-label">
                                            <Controller name="opayoProductionIntegrationPassword" control={control}
                                                        render={({ field, fieldState }) => (
                                                            <InputText id={field.name} {...field}
                                                            />
                                                        )}
                                            />
                                            <label htmlFor="opayoProductionIntegrationPassword">Opayo Integration Password</label>
                                        </span>
                                        {getFormErrorMessage('opayoProductionIntegrationPassword')}
                                    </div>
                                </div>
                            </>
                        }

                        {(opayoServiceActive && opayoSandboxStatus) &&
                            <>
                                <h5>Opayo Sandbox Environment Settings</h5>
                                <div className="p-fluid grid formgrid" >
                                    <div className="field col-6" style={{paddingTop: '27px'}}>
                                        <span className="p-float-label">
                                            <Controller name="opayoSandboxVendorName" control={control}
                                                        render={({ field, fieldState }) => (
                                                            <InputText id={field.name} {...field}
                                                            />
                                                        )}
                                            />
                                            <label htmlFor="opayoSandboxVendorName">Opayo SANDBOX Vendor Name</label>
                                        </span>
                                        {getFormErrorMessage('opayoSandboxVendorName')}
                                    </div>
                                    <div className="field col-6" style={{paddingTop: '27px'}}>
                                        <span className="p-float-label">
                                            <Controller name="opayoSandboxIntegrationKey" control={control}
                                                        render={({ field, fieldState }) => (
                                                            <InputText id={field.name} {...field}
                                                            />
                                                        )}
                                            />
                                            <label htmlFor="opayoSandboxIntegrationKey">Opayo SANDBOX Integration Key</label>
                                        </span>
                                        {getFormErrorMessage('opayoSandboxIntegrationKey')}
                                    </div>
                                    <div className="field col-6" style={{paddingTop: '27px'}}>
                                        <span className="p-float-label">
                                            <Controller name="opayoSandboxIntegrationPassword" control={control}
                                                        render={({ field, fieldState }) => (
                                                            <InputText id={field.name} {...field}
                                                            />
                                                        )}
                                            />
                                            <label htmlFor="opayoSandboxIntegrationPassword">Opayo SANDBOX Integration Password</label>
                                        </span>
                                        {getFormErrorMessage('opayoSandboxIntegrationPassword')}
                                    </div>
                                </div>
                            </>
                        }

                        <div className="col-12">
                            <div className="p-fluid grid">
                                <div className="field col-12 md:col-9"></div>
                                <div className="field col-12 md:col-3">
                                    <Button label="Update Opayo Settings"
                                            severity="warning"
                                            disabled={submitButtonDisabled}
                                            style={themeSettings.buttonColor ? {background: `#${themeSettings.buttonColor}`} : {background: '#f97316'}}
                                    />
                                </div>
                            </div>
                        </div>

                    </form>
                </div>
            </div>
        </>
    )
}